import { useDataLoader } from '../../../../hooks'
import {
  getMockCalendarSettings,
  updateMockCalendarSettings,
} from '../../CalendarSettings.mock'

export function useCalendarSettingsData() {
  // TODO: read the settings from the calendar settings endpoint once the
  // backend serves it.
  const {
    data: settings,
    isLoading,
    serverError,
    setData: setSettings,
  } = useDataLoader({ getData: getMockCalendarSettings })

  // TODO: save through the calendar settings endpoint once the backend
  // serves it.
  async function handleSaveSettings(payload) {
    return updateMockCalendarSettings(payload).then(({ data }) => {
      setSettings(data)
    })
  }

  return {
    handleSaveSettings,
    isLoading,
    serverError,
    settings,
  }
}
